// extracted by mini-css-extract-plugin
export default {"root":"NotificationLayout_root__6qmAO","unread":"NotificationLayout_unread__5QSKl"};